/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sduniklinikum13Inputs */

const en__field_enum_sduniklinikum13 = /** @type {(inputs: _Field_Enum_Sduniklinikum13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uniklinikum Frankfurt`)
};

const de__field_enum_sduniklinikum13 = /** @type {(inputs: _Field_Enum_Sduniklinikum13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uniklinikum Frankfurt`)
};

/**
* | output |
* | --- |
* | "Uniklinikum Frankfurt" |
*
* @param {_Field_Enum_Sduniklinikum13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sduniklinikum13 = /** @type {((inputs?: _Field_Enum_Sduniklinikum13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sduniklinikum13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sduniklinikum13(inputs)
	return de__field_enum_sduniklinikum13(inputs)
});
export { _field_enum_sduniklinikum13 as "_field_enum_SDUNIKLINIKUM" }